import React, { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { useLocation, useParams } from 'react-router';
import styled from 'styled-components';
import TopNewsHeader from 'app/components/topNewsModule/header/TopNewsHeader';
import { COLORS } from '@fupa/fupa-uikit';
import MainNews from 'app/components/topNewsModule/mainNews/MainNews';
import ResponsiveNewsList from 'app/components/topNewsModule/subNews/ResponsiveNewsList';
import LoadingSkeleton from 'app/components/topNewsModule/LoadingSkeleton';
import TopNewsError from 'app/components/topNewsModule/TopNewsError';
import { fetchTopNewsList } from 'app/queries/districtNews';
import TopNewsPlaceholder from 'app/components/topNewsModule/TopNewsPlaceholder';
import FuPaApiError from 'app/models/error/FuPaApiError';
const Wrapper = styled.div.withConfig({
  componentId: "sc-11fc620-0"
})(["display:flex;flex-direction:column;width:100%;background-color:", ";"], COLORS.white);
export default function TopNewsModule(_ref) {
  let {
    initialData
  } = _ref;
  const {
    districtSlug
  } = useParams();
  const location = useLocation();
  const {
    data,
    isError,
    refetch,
    isLoading
  } = useQuery({
    queryKey: ['top-news', {
      districtSlug
    }],
    queryFn: () => fetchTopNewsList(districtSlug),
    initialData: initialData,
    onError: error => error // only used for typing purposes
  });
  const subNews = useMemo(() => {
    if (!data) {
      return [];
    }
    if (data instanceof FuPaApiError) {
      return [];
    }
    if (data.length < 2) {
      return [];
    }
    return data.slice(1);
  }, [data]);
  if (isLoading) {
    return /*#__PURE__*/React.createElement(Wrapper, null, /*#__PURE__*/React.createElement(TopNewsHeader, {
      pathname: location.pathname
    }), /*#__PURE__*/React.createElement(LoadingSkeleton, null));
  }
  if (isError || !data) {
    return /*#__PURE__*/React.createElement(Wrapper, null, /*#__PURE__*/React.createElement(TopNewsHeader, null), /*#__PURE__*/React.createElement(TopNewsError, {
      onRetry: refetch
    }));
  }
  if (data instanceof FuPaApiError) {
    return /*#__PURE__*/React.createElement(Wrapper, {
      id: data.getHttpStatusId()
    }, /*#__PURE__*/React.createElement(TopNewsHeader, null), /*#__PURE__*/React.createElement(TopNewsError, {
      onRetry: refetch
    }));
  }
  if (!data.length) {
    return /*#__PURE__*/React.createElement(Wrapper, null, /*#__PURE__*/React.createElement(TopNewsHeader, {
      pathname: location.pathname
    }), /*#__PURE__*/React.createElement(TopNewsPlaceholder, null));
  }
  return /*#__PURE__*/React.createElement(Wrapper, {
    "data-sentry-element": "Wrapper",
    "data-sentry-component": "TopNewsModule",
    "data-sentry-source-file": "TopNewsModule.tsx"
  }, /*#__PURE__*/React.createElement(TopNewsHeader, {
    pathname: location.pathname,
    "data-sentry-element": "TopNewsHeader",
    "data-sentry-source-file": "TopNewsModule.tsx"
  }), /*#__PURE__*/React.createElement(MainNews, {
    data: data[0],
    "data-sentry-element": "MainNews",
    "data-sentry-source-file": "TopNewsModule.tsx"
  }), /*#__PURE__*/React.createElement(ResponsiveNewsList, {
    newsList: subNews,
    "data-sentry-element": "ResponsiveNewsList",
    "data-sentry-source-file": "TopNewsModule.tsx"
  }));
}